"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserData = void 0;
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
// istanbul ignore file @preserve -- api

const getUserData = async ({
  customerId,
  globalApiClient,
  tenant
}) => {
  const [emailsResponse, phonesResponse] = await Promise.all([(0, _globalApiClientReact.getCustomerEmails)(globalApiClient, customerId, {
    [_fetching.TENANT_CONTEXT]: tenant
  }, {
    validateStatus: _fetching.validateStatus
  }), (0, _globalApiClientReact.getCustomerPhones)(globalApiClient, customerId, {
    [_fetching.TENANT_CONTEXT]: tenant
  }, {
    validateStatus: _fetching.validateStatus
  })]);
  const email = (0, _fetching.handleResponse)(emailsResponse, {
    onError: () => null,
    onSuccess: res => res.data.emails[0]?.emailAddress ?? null
  });
  const telephoneNumber = (0, _fetching.handleResponse)(phonesResponse, {
    onError: () => null,
    onSuccess: res => res.data.telephonesCollection.find(telephone => telephone.isPrimary)?.telephoneNumber ?? null
  });
  return {
    email,
    telephoneNumber
  };
};
exports.getUserData = getUserData;
